import { permissionShowOnboardingTooltip } from '@atom/worksheetAtom';
import { useStudentOnboardingTooltipPermission } from '@hooks/user.hook';
import {
  TOUR_ONBOARDING_FLAG,
  TOUR_ONBOARDING_STEP_COUNT_KEY,
} from '@utils/constants/tour.constants';
import { useAtom } from 'jotai';
import { useEffect } from 'react';

export function useOnboardingTooltipPermission() {
  const queryGetStudentOnboardingTooltipPermission =
    useStudentOnboardingTooltipPermission();
  const [, setIsAllowShowOnboardingTooltip] = useAtom(
    permissionShowOnboardingTooltip,
  );

  useEffect(() => {
    if (
      queryGetStudentOnboardingTooltipPermission.isSuccess &&
      queryGetStudentOnboardingTooltipPermission.data.data.data
        ?.is_show_onboarding_tooltip
    ) {
      setIsAllowShowOnboardingTooltip(true);
    } else if (
      queryGetStudentOnboardingTooltipPermission.isSuccess &&
      !queryGetStudentOnboardingTooltipPermission.data.data.data
        ?.is_show_onboarding_tooltip
    ) {
      // set cookie as done if not allowed
      localStorage.setItem(TOUR_ONBOARDING_FLAG, '1');
      localStorage.setItem(TOUR_ONBOARDING_STEP_COUNT_KEY, '4');
      localStorage.setItem('alreadyTakeProgressTour', 'true');
      localStorage.setItem('mcqTourIdentifier', 'true');
      localStorage.setItem('sqTourIdentifier', 'true');
      localStorage.setItem('tourWsCompletedIdentifier', 'true');
    }
  }, [queryGetStudentOnboardingTooltipPermission]);
}
